<i18n src="../../../locales/lang.json"></i18n>
<template>
  <div style="margin-right:20px;position:absolute !important; right:0px;" class="btn-group justify-content-center">
    <element-selector ref="selector" @selected_element="addedElement"></element-selector>
    <a href="#" class="" data-toggle="dropdown" data-boundary="viewport" style="color:inherit"><i class="icon-menu"></i></a>
    <div class="skinnedmenu dropdown-menu viewportfix">
      <div v-on:click="clickSettings(el);" class="dropdown-item">{{ $t('settings') }}</div>
      <div v-on:click="deleteItem([el.Id]);" class="dropdown-item">{{ $t('remove') }}</div>
      <div v-if="el.ElementType == 4 || el.ElementType == 12 || el.ElementType == 13 || el.ElementType == 14 || el.ElementType == 15" v-on:click="openSelector" class="dropdown-item">{{ $t('add') }}</div>
    </div>
  </div>
</template>

<script>

  export default {
    name: "element-controls",
    components: {
      
    },
    props: {
      scheduleid: {
        required: false,
        type: String,
        default: null
      },
      el: {
        type: Object,
        default: null
      },
      overelement: {
        type: Object,
        default: null
      },
    },
    data() {
      return {

      };
    },
    methods: {
      addedElement(newElement) {
        this.el.Elements.push(newElement);
      },
      openSelector() {
        this.$refs.selector.open();
      },
      clickSettings(el) {
        this.$emit('clickSettings', el);
      },
      clickItem(el) {
        this.$emit('clickItem', el);
      },
      deleteItem(id) {
        if (id == null || typeof id == "undefined")
          id = this.value.Id;
        this.$emit('deleteItem', id);
      },
      getId() {
        return this._uid;
      },
    },
    computed: {

    },
    watch: {
      
    },
    mounted() {
      
    },
    created() {

    },
  };

</script>

<style scoped>
  
</style>



// WEBPACK FOOTER //
// src/components/procedure/procedure-editor-elements/element-controls.vue